import * as React from 'react';
import { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@material-ui/core';
import Person from '@material-ui/icons/Person';
import { useApi } from '@backstage/core-plugin-api';
import { identityApiRef } from '@backstage/core-plugin-api';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const CustomUserField = ({
  onChange,
  required,
  formData,
  schema,
  rawErrors,
}: FieldExtensionComponentProps<string>) => {
  const [userRef, setUserRef] = useState<string>('');
  const identityApi = useApi(identityApiRef);

  // Extract schema properties
  const {
    title,
    description,
    placeholder,
    helperText,
  } = schema;

  // Get user context on component mount
  useEffect(() => {
    const getUserRef = async () => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        const userRef = identity.userEntityRef;
        setUserRef(userRef);
        // Automatically set the value when user context is loaded
        if (userRef && !formData) {
          onChange(userRef);
        }
      } catch (error) {
        console.error('Failed to get user identity:', error);
        setUserRef('user:default/unknown');
        if (!formData) {
          onChange('user:default/unknown');
        }
      }
    };

    getUserRef();
  }, [identityApi, onChange, formData]);

  // Check for form validation errors
  const hasFormValidationErrors = rawErrors && rawErrors.length > 0;
  const hasError = hasFormValidationErrors;
  const displayError = hasFormValidationErrors ? '' : (helperText || description);

  return (
    <TextField
      fullWidth
      label={title}
      value={formData || userRef}
      onChange={(event) => onChange(event.target.value)}
      error={hasError}
      helperText={displayError}
      placeholder={placeholder || 'user:default/username'}
      required={required}
      disabled={true} // Make it read-only since it's auto-populated
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Person />
          </InputAdornment>
        ),
      }}
    />
  );
};